// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffportal/v1/user_service.proto (package bffportal.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_acl_v1_acl } from "../../acl/v1/acl_pb";
import type { Me } from "./user_model_pb";
import { file_bffportal_v1_user_model } from "./user_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffportal/v1/user_service.proto.
 */
export const file_bffportal_v1_user_service: GenFile = /*@__PURE__*/
  fileDesc("Ch9iZmZwb3J0YWwvdjEvdXNlcl9zZXJ2aWNlLnByb3RvEgxiZmZwb3J0YWwudjEiDgoMR2V0TWVSZXF1ZXN0Ii0KDUdldE1lUmVzcG9uc2USHAoCbWUYASABKAsyEC5iZmZwb3J0YWwudjEuTWUiPAoZVXBkYXRlVXNlckxhbmd1YWdlUmVxdWVzdBIfCghsYW5ndWFnZRgBIAEoCUINukgKcghSAmphUgJlbiIcChpVcGRhdGVVc2VyTGFuZ3VhZ2VSZXNwb25zZTKbAgoLVXNlclNlcnZpY2UScQoFR2V0TWUSGi5iZmZwb3J0YWwudjEuR2V0TWVSZXF1ZXN0GhsuYmZmcG9ydGFsLnYxLkdldE1lUmVzcG9uc2UiL5qQGysKE2VjbGVhci1iYXNpYy1tYXN0ZXIKFGVjbGVhci1iYXNpYy1kZWZhdWx0EpgBChJVcGRhdGVVc2VyTGFuZ3VhZ2USJy5iZmZwb3J0YWwudjEuVXBkYXRlVXNlckxhbmd1YWdlUmVxdWVzdBooLmJmZnBvcnRhbC52MS5VcGRhdGVVc2VyTGFuZ3VhZ2VSZXNwb25zZSIvmpAbKwoTZWNsZWFyLWJhc2ljLW1hc3RlcgoUZWNsZWFyLWJhc2ljLWRlZmF1bHRCwQEKEGNvbS5iZmZwb3J0YWwudjFCEFVzZXJTZXJ2aWNlUHJvdG9QAVpKZ2l0aHViLmNvbS9lbmVjaGFpbi9lcG9zaXRpb24tYXBwL2JhY2tlbmQvZ2VuL3Byb3RvL2JmZnBvcnRhbC92MTtiZmZwb3J0YWyiAgNCWFiqAgxCZmZwb3J0YWwuVjHKAgxCZmZwb3J0YWxcVjHiAhhCZmZwb3J0YWxcVjFcR1BCTWV0YWRhdGHqAg1CZmZwb3J0YWw6OlYxYgZwcm90bzM", [file_acl_v1_acl, file_bffportal_v1_user_model, file_buf_validate_validate]);

/**
 * @generated from message bffportal.v1.GetMeRequest
 */
export type GetMeRequest = Message<"bffportal.v1.GetMeRequest"> & {
};

/**
 * Describes the message bffportal.v1.GetMeRequest.
 * Use `create(GetMeRequestSchema)` to create a new message.
 */
export const GetMeRequestSchema: GenMessage<GetMeRequest> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_user_service, 0);

/**
 * @generated from message bffportal.v1.GetMeResponse
 */
export type GetMeResponse = Message<"bffportal.v1.GetMeResponse"> & {
  /**
   * @generated from field: bffportal.v1.Me me = 1;
   */
  me?: Me;
};

/**
 * Describes the message bffportal.v1.GetMeResponse.
 * Use `create(GetMeResponseSchema)` to create a new message.
 */
export const GetMeResponseSchema: GenMessage<GetMeResponse> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_user_service, 1);

/**
 * @generated from message bffportal.v1.UpdateUserLanguageRequest
 */
export type UpdateUserLanguageRequest = Message<"bffportal.v1.UpdateUserLanguageRequest"> & {
  /**
   * @generated from field: string language = 1;
   */
  language: string;
};

/**
 * Describes the message bffportal.v1.UpdateUserLanguageRequest.
 * Use `create(UpdateUserLanguageRequestSchema)` to create a new message.
 */
export const UpdateUserLanguageRequestSchema: GenMessage<UpdateUserLanguageRequest> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_user_service, 2);

/**
 * @generated from message bffportal.v1.UpdateUserLanguageResponse
 */
export type UpdateUserLanguageResponse = Message<"bffportal.v1.UpdateUserLanguageResponse"> & {
};

/**
 * Describes the message bffportal.v1.UpdateUserLanguageResponse.
 * Use `create(UpdateUserLanguageResponseSchema)` to create a new message.
 */
export const UpdateUserLanguageResponseSchema: GenMessage<UpdateUserLanguageResponse> = /*@__PURE__*/
  messageDesc(file_bffportal_v1_user_service, 3);

/**
 * @generated from service bffportal.v1.UserService
 */
export const UserService: GenService<{
  /**
   * @generated from rpc bffportal.v1.UserService.GetMe
   */
  getMe: {
    methodKind: "unary";
    input: typeof GetMeRequestSchema;
    output: typeof GetMeResponseSchema;
  },
  /**
   * @generated from rpc bffportal.v1.UserService.UpdateUserLanguage
   */
  updateUserLanguage: {
    methodKind: "unary";
    input: typeof UpdateUserLanguageRequestSchema;
    output: typeof UpdateUserLanguageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffportal_v1_user_service, 0);

